import { handleActions } from 'redux-actions';
import * as Actions from '../constants/actions';
import { UserData } from '../models/User';

const initialState: UserData = {
	_id: '',
	firstname: '',
	lastname: '',
	username: 'NotLoggedIn',
	password: '',
	school: ''
};

export default handleActions<UserData, UserData>(
	{

		[Actions.USER_LOGIN]: (state, action) => {
			return Object.assign({}, action.payload);
		},

		[Actions.USER_AUTHENTICATE]: (state, action) => {
			return Object.assign({}, action.payload);
		},

		[Actions.USER_REGISTER]: (state, action) => {
			return Object.assign({}, action.payload);
		},

		[Actions.USER_UPDATE]: (state, action) => {
			console.log('state:', state)
			console.log('action:', action.payload)
			const newState = {
				...state,
				...action.payload
			}
			return newState;
		}
	},
	initialState
);



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/reducers/user.ts